import timeToMs from "./timeToMs";

export default function timeToSeconds(value) {
	return timeToMs(value) / 1000;
}
